var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle, _ellipse, _ellipse2, _path7, _path8, _path9, _ellipse3, _ellipse4, _path10, _path11, _circle2, _circle3, _circle4, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9b233;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-8{stroke:#000;}.cls-2,.cls-8{stroke-miterlimit:10;stroke-width:2.11px;}.cls-3{fill:#575756;}.cls-3,.cls-4,.cls-5,.cls-6{stroke-linecap:round;stroke-linejoin:round;}.cls-3,.cls-4{stroke-width:5.62px;}.cls-4{fill:#fffbbd;}.cls-5{fill:#f9c975;stroke-width:2.66px;}.cls-6{fill:#fff;stroke-width:2.81px;}.cls-7{fill:#ff9791;}.cls-8{fill:#9fcfe3;}.cls-9{font-size:43.22px;font-family:GochiHand-Regular, Gochi Hand;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -0.12,
    width: 500,
    height: 500
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.13,390a4.39,4.39,0,0,1,1.76,1.57,1.79,1.79,0,0,1-.29,2.18c-1,.76-2.59,0-3.43.9s-.23,2.22-.94,3c-1.25,1.46-4.16-.95-5.4.51a12.23,12.23,0,0,0-.67,1.47c-.69,1.18-2.42,1.11-3.72.68-2.71-.88-5.36-3-5.54-5.84a6.25,6.25,0,0,1,3.16-5.42C285.54,386.28,291.81,387.46,296.13,390Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.05,390a4.39,4.39,0,0,0-1.76,1.57,1.79,1.79,0,0,0,.29,2.18c.95.76,2.59,0,3.43.9s.23,2.22.94,3c1.25,1.46,4.16-.95,5.4.51.35.42.39,1,.67,1.47.69,1.18,2.42,1.11,3.72.68,2.71-.88,5.36-3,5.54-5.84a6.25,6.25,0,0,0-3.16-5.42C201.64,386.28,195.37,387.46,191.05,390Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M352.62,284.27s28.87-27.28,25.1-38.34-48.86,10.31-48.86,10.31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.4,289.92s-35.84,17.15-44.8,9.66,27.16-41.9,27.16-41.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267,140.5a27.68,27.68,0,0,1-.2,4.09l-48.7,1.9a24.56,24.56,0,0,1,18.6-29.09,22.28,22.28,0,0,1,4.61-.63,23,23,0,0,1,5.47.41A24.7,24.7,0,0,1,267,140.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M252,143.66l-19,.75a50.31,50.31,0,0,1,0-14.08,36.35,36.35,0,0,1,3.73-11.52,25.6,25.6,0,0,1,4.62-.58,25.31,25.31,0,0,1,5.47.34c.4.94.77,1.88,1.09,2.86A74,74,0,0,1,252,143.66Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240.98,
    cy: 112.92,
    r: 2.47
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.07,
    cy: 113.16,
    rx: 8.85,
    ry: 1.08,
    transform: "translate(-4.24 9.18) rotate(-2.24)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.22,
    cy: 112.19,
    rx: 8.85,
    ry: 1.08,
    transform: "translate(-4.19 9.81) rotate(-2.24)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M349.75,268.45a63.39,63.39,0,0,1-4.89-25.5c.68-33.38-11.3-57.81-28.45-74.94a108.4,108.4,0,0,0-42.06-26.21c-25.68-8.48-52.87-3.58-61.56-.54a121.07,121.07,0,0,0-30.93,16c-23.56,17-41.92,44.58-41.09,85.68a63.39,63.39,0,0,1-4.89,25.5c-21,50.86-5.88,115.32,59,121.22,15.7,1.43,32,2.38,47.93,2.24,16,.14,32.24-.81,47.94-2.24C355.63,383.77,370.73,319.31,349.75,268.45Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.12,277.54a73.61,73.61,0,0,1-4.73-27.2c.42-22.66-5.91-41.49-18.82-56C286.34,176.16,262,168,245.1,168c-.78,0-1.54,0-2.29.07s-1.5-.07-2.28-.07c-16.92,0-41.25,8.15-57.47,26.35-12.91,14.49-19.24,33.32-18.83,56a73.39,73.39,0,0,1-4.72,27.2c-8.76,23.34-8.24,48.67,1.36,66.1,7.45,13.52,17.93,17.75,36.21,22.88,9.64,2.71,25.88,3.78,37.54,4.13,1.34.05,2.7.08,4.08.1l2.24,0,1.14,0h1.47l1.14,0,2.23,0c1.38,0,2.75-.05,4.08-.1,11.67-.35,27.91-1.42,37.55-4.13,18.27-5.13,28.76-9.36,36.21-22.88C334.36,326.21,334.88,300.88,326.12,277.54Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.07,243.54a15.06,15.06,0,0,0-10.66.16,4.27,4.27,0,0,0-2.47,5c.74,3,2.94,6.62,6.95,7.37,5.05,0,8-4.14,8.69-8.05A4,4,0,0,0,248.07,243.54Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 286.34,
    cy: 264.34,
    rx: 8.43,
    ry: 6,
    transform: "translate(-84.43 144.34) rotate(-24.78)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 198.09,
    cy: 263.52,
    rx: 6,
    ry: 8.43,
    transform: "translate(-131.55 267.58) rotate(-53.77)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M235.85,290.58a5.06,5.06,0,0,1-4.06.21c-1.43-.74-1.95-2.53-2.07-4.15a15.91,15.91,0,0,1,.46-5.05,5,5,0,0,1,2.39-3.51,4,4,0,0,1,3,0,11.85,11.85,0,0,1,2.63,1.56,16.29,16.29,0,0,1,3,2.53C244.88,286.6,239.65,289.12,235.85,290.58Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M249.61,290.58a5.06,5.06,0,0,0,4.06.21c1.43-.74,2-2.53,2.07-4.15a15.91,15.91,0,0,0-.46-5.05,5,5,0,0,0-2.39-3.51,4,4,0,0,0-3,0,11.85,11.85,0,0,0-2.63,1.56,16.29,16.29,0,0,0-3,2.53C240.58,286.6,245.81,289.12,249.61,290.58Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 243.03,
    cy: 284.47,
    r: 2.92
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.45,
    cy: 250.41,
    r: 10.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.78,
    cy: 250.41,
    r: 10.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "matrix(0.86, 0.5, -0.5, 0.86, 307.96, 131.62)"
  }, "Hi!")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.a853bfa49d5b8533e5c912649b8bd506.svg";
export { ForwardRef as ReactComponent };